import {
  CareerSiteFiltersOption,
  CareerSiteSettings,
  CategoryOptions,
  RadiusOptions,
} from 'api-clients/monolith';
import cx from 'classnames';
import React, { useRef } from 'react';

import { HomeMain } from 'components/home-main';
import { HomeSearch } from 'components/home-search';

import { Banner } from './banner-image';

interface HomeProps {
  bannerUrl: string | null;
  brandSetting: CareerSiteSettings;
  radiusOptions: RadiusOptions[];
  categoryOptions: CategoryOptions[];
  departmentOptions: CareerSiteFiltersOption[];
  compensationTypeOptions: CareerSiteFiltersOption[];
}

export function Home({
  bannerUrl,
  brandSetting,
  radiusOptions,
  categoryOptions,
  departmentOptions,
  compensationTypeOptions,
}: HomeProps) {
  const targetRef = useRef<HTMLDivElement>(null);

  const scrollToJobs = () => {
    if (targetRef.current) {
      const targetPosition = targetRef.current.offsetTop;

      // Scroll to the target element with a 64px offset to deduct the menubar height
      window.scrollTo({
        top: targetPosition - 64,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="flex flex-col">
      {bannerUrl && <Banner bannerUrl={bannerUrl} />}
      <div className="w-full">
        <HomeSearch
          scrollToJobs={scrollToJobs}
          brandSetting={brandSetting}
          showBackground={!bannerUrl}
        />
      </div>
      <div ref={targetRef}></div>
      <div
        className={cx('container flex flex-col gap-6 pb-20 pt-10', {
          '!pt-0': bannerUrl,
        })}
      >
        <HomeMain
          scrollToJobs={scrollToJobs}
          brandSetting={brandSetting}
          radiusOptions={radiusOptions}
          categoryOptions={categoryOptions}
          departmentOptions={departmentOptions}
          compensationTypeOptions={compensationTypeOptions}
        />
      </div>
    </div>
  );
}

Home.Skeleton = function HomeSkeleton() {
  return (
    <div className="flex flex-col">
      <Banner.Skeleton />
      <div className="h-[346px] w-full">
        <HomeSearch.Skeleton />
      </div>

      <div className="container flex flex-col gap-8 pb-20 pt-10">
        <HomeMain.Skeleton />
      </div>
    </div>
  );
};
